import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sh_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const PLACEHOLDER =
  "data:image/svg+xml;charset=utf-8," +
  encodeURIComponent(
    "<svg xmlns='http://www.w3.org/2000/svg' width='160' height='120'><rect width='100%' height='100%' fill='#f4f5f9'/><path d='M60 78l18-22 14 16 10-12 18 18v6H60z' fill='#c7cdd6'/><circle cx='64' cy='48' r='8' fill='#c7cdd6'/></svg>"
  );

export function resolveImg(idOrUrl) {
  if (!idOrUrl) return null;
  if (idOrUrl.startsWith("http")) {
    if (idOrUrl.includes("images.unsplash.com") || idOrUrl.includes("images.pexels.com")) {
      return `${API}/media-proxy?url=${encodeURIComponent(idOrUrl)}`;
    }
    return idOrUrl;
  }
  return `${API}/files/${idOrUrl}`;
}

export function imgFallback(e) {
  e.target.onerror = null;
  e.target.src = PLACEHOLDER;
}

export function inr(value) {
  const n = Number(value || 0);
  if (n >= 10000000) return `₹${(n / 10000000).toFixed(2)} Cr`;
  if (n >= 100000) return `₹${(n / 100000).toFixed(2)} L`;
  return `₹${n.toLocaleString("en-IN")}`;
}

export function inrFull(value) {
  return `₹${Number(value || 0).toLocaleString("en-IN")}`;
}

export function num(value) {
  return Number(value || 0).toLocaleString("en-IN");
}

export default api;
